import { LEAD_STATUSES } from "@/lib/constants";

const STATUS_CLASS = {
  new_lead: "bg-[#18E096]/15 text-[#18E096] border-[#18E096]/30",
  qualified: "bg-[#18E096]/25 text-[#18E096] border-[#18E096]/50",
  not_fit: "bg-red-500/10 text-red-300 border-red-500/30",
};

export default function StatusBadge({ status }) {
  const cls =
    STATUS_CLASS[status] ||
    "bg-white/5 text-[#AEB7B7] border-[rgba(255,255,255,0.12)]";
  const label =
    LEAD_STATUSES.find((s) => s.value === status)?.label || status;
  return (
    <span
      className={`inline-block text-[10px] uppercase tracking-widest px-2 py-1 border ${cls}`}
    >
      {label}
    </span>
  );
}
